import { z } from 'zod';

/**
 * Fio entre serviços (mobility-batch publica, live-activity consome): sem `_schemaVersion`, a
 * `version` do corpo é o contrato. `userId` é o legado do link e nunca vai a log.
 */
export const RideLinkPushEventSchema = z
  .object({
    version: z.literal(1),
    pushId: z.uuid(),
    kind: z.enum(['released', 'period_start']),
    linkId: z.uuid(),
    userId: z.string().min(1),
    clientName: z.string(),
    batchName: z.string(),
    startsAt: z.iso.datetime(),
    endsAt: z.iso.datetime(),
  })
  .strict();
export type RideLinkPushEvent = z.infer<typeof RideLinkPushEventSchema>;
